import { Validator } from '@vista-digital/validator';
import { FieldFormatType } from '../../../../types/form/field-format-type';
import { emailFieldValidationConfigValidator, otherFieldValidationConfigValidator, textFieldValidationConfigValidator, textFieldValidationConfigValidatorSchema } from '../../../../types/form/field-validation-config';
export const defaultMemberSignInFormValidationConfig = {
    email: { type: FieldFormatType.Email },
    username: { type: FieldFormatType.Text, maxLength: 100 },
    password: {
        type: FieldFormatType.Text,
        required: true,
        maxLength: 64 // Loyalty currently has a technical limitation of 64 characters.
    },
    remember: { type: FieldFormatType.Other, required: false },
    captcha: { type: FieldFormatType.Other, required: true }
};
export const memberSignInFormValidationConfigValidator = Validator.object({
    email: emailFieldValidationConfigValidator,
    username: textFieldValidationConfigValidator,
    password: Validator.object(Object.assign(Object.assign({}, textFieldValidationConfigValidatorSchema), { required: Validator.isEqualTo(true) })),
    remember: otherFieldValidationConfigValidator,
    captcha: otherFieldValidationConfigValidator
});
//# sourceMappingURL=validation-config.js.map